import axios from "axios";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { ReportDescriptionRetrieveInterface } from "../../../middleware/interfaces/report/report-description-retrieve-interface";

export const ReportDescriptionRetrieve = {
  Retrieve: async (state: UserStateInterface) => {
    let serverResponse;
    if (state.data) {
      const reportDescriptionRetrieveData: ReportDescriptionRetrieveInterface =
        state.data;
      const url = "./php/report/report-description-retriever-proxy.php";
      await axios
        .post(url, reportDescriptionRetrieveData)
        .then((response) => {
          serverResponse = response.data;
        })
        .catch((error) => {
          serverResponse = {
            status: "error",
            header: "error",
            message: error.message,
          };
        });
    } else {
      serverResponse = {
        status: "error",
        header: "error",
        message: "Something went wrong! Please contact DigitalCharcoal",
      };
    }
    return serverResponse;
  },
};
